var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C2.23875 10 0 7.76125 0 5C0 2.23875 2.23875 0 5 0C7.76125 0 10 2.23875 10 5C10 7.76125 7.76125 10 5 10ZM4.375 5.625C4.375 5.79076 4.44085 5.94973 4.55806 6.06694C4.67527 6.18415 4.83424 6.25 5 6.25C5.16576 6.25 5.32473 6.18415 5.44194 6.06694C5.55915 5.94973 5.625 5.79076 5.625 5.625V2.5C5.625 2.33424 5.55915 2.17527 5.44194 2.05806C5.32473 1.94085 5.16576 1.875 5 1.875C4.83424 1.875 4.67527 1.94085 4.55806 2.05806C4.44085 2.17527 4.375 2.33424 4.375 2.5V5.625ZM5 6.865C4.9179 6.86502 4.83661 6.88121 4.76078 6.91265C4.68494 6.94408 4.61603 6.99015 4.55799 7.04821C4.49996 7.10628 4.45393 7.17521 4.42253 7.25106C4.39113 7.32692 4.37498 7.40822 4.375 7.49031C4.37502 7.57241 4.39121 7.6537 4.42265 7.72954C4.45408 7.80538 4.50015 7.87428 4.55821 7.93232C4.61628 7.99036 4.68521 8.03639 4.76106 8.06779C4.83692 8.09918 4.91822 8.11533 5.00031 8.11531C5.16611 8.11527 5.32511 8.04937 5.44232 7.9321C5.55953 7.81483 5.62535 7.6558 5.62531 7.49C5.62527 7.3242 5.55937 7.1652 5.4421 7.04799C5.32483 6.93078 5.1658 6.86496 5 6.865Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyInfo);
export default __webpack_public_path__ + "static/media/EmergencyInfo.f917f584a86bfae95b0978fff0e8cd38.svg";
export { ForwardRef as ReactComponent };